var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 1.6665H5.83342C3.53341 1.6665 1.66675 3.52484 1.66675 5.8165V10.7998V11.6332C1.66675 13.9248 3.53341 15.7832 5.83342 15.7832H7.08342C7.30841 15.7832 7.60842 15.9332 7.75008 16.1165L9.00008 17.7748C9.55008 18.5082 10.4501 18.5082 11.0001 17.7748L12.2501 16.1165C12.4084 15.9082 12.6584 15.7832 12.9167 15.7832H14.1667C16.4667 15.7832 18.3334 13.9248 18.3334 11.6332V5.8165C18.3334 3.52484 16.4667 1.6665 14.1667 1.6665ZM6.66675 9.99984C6.20008 9.99984 5.83342 9.62484 5.83342 9.1665C5.83342 8.70817 6.20842 8.33317 6.66675 8.33317C7.12508 8.33317 7.50008 8.70817 7.50008 9.1665C7.50008 9.62484 7.13341 9.99984 6.66675 9.99984ZM10.0001 9.99984C9.53342 9.99984 9.16675 9.62484 9.16675 9.1665C9.16675 8.70817 9.54175 8.33317 10.0001 8.33317C10.4584 8.33317 10.8334 8.70817 10.8334 9.1665C10.8334 9.62484 10.4667 9.99984 10.0001 9.99984ZM13.3334 9.99984C12.8667 9.99984 12.5001 9.62484 12.5001 9.1665C12.5001 8.70817 12.8751 8.33317 13.3334 8.33317C13.7917 8.33317 14.1667 8.70817 14.1667 9.1665C14.1667 9.62484 13.8001 9.99984 13.3334 9.99984Z",
    fill: "#00a14b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBold);
export default __webpack_public_path__ + "static/media/message-bold.0de36310b341659f5867ab5d33acaff5.svg";
export { ForwardRef as ReactComponent };